export const Input = 'Input';
export const ExamManage = 'ExamManage';
export const PaymentManage = 'PaymentManage';
export const PromptLogin = 'PromptLogin';
export const LoginCallBack = 'LoginCallBack';
export const SilentCallBack = 'SilentCallBack';
export const Logout = 'Logout';
